import SigningLinkButtons from '@/components/PersonOfInterest/SigningLinkButtons.vue'
import type { ColumnDef } from '@tanstack/vue-table'
import { h } from 'vue'
import { PersonsOfInterestEmbeds } from '../tables/PersonsOfInterest'

const personsOfInterestColumns: ColumnDef<PersonsOfInterestEmbeds.ListItem>[] = [
  {
    accessorKey: 'name',
    size: 200,
  },
  {
    accessorKey: 'titleList',
    header: 'Titler',
  },
  {
    accessorKey: 'signatureRequired',
  },
  {
    accessorKey: 'signedAt',
  },
  {
    id: 'actions',
    meta: {
      placement: 'end',
    },
    size: 20,
    cell: ({ row }) => {
      return h(SigningLinkButtons, {
        personOfInterest: row.original,
      })
    },
  },
]

export default personsOfInterestColumns
